import React, { FC, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { CopyButton } from "./CopyBtn";

interface Props {
  iframeUrl: string;
  scriptTagProps: any;
}

export const WebsiteChannel: FC<Props> = (props) => {
  const { iframeUrl, scriptTagProps } = props;

  const formatEmbedCode = useMemo(
    () => `
    <script ${Object.entries(scriptTagProps)
      .map(([key, value]: any) => `${key}="${value}"`)
      .join(" ")}></script>
  `,
    [scriptTagProps]
  );

  const formatEmbedReactHookCode = useMemo(
    () => `
    useEffect(() => {
      {/* @ts-ignore */}
      window.tdcEmbedLoaded = false;
      {/* @ts-ignore */}
      window.tdcEmbedSingleLoaded = false;
      const script = document.createElement('script');
      script.src = "${iframeUrl}";       
      script.async = true;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      }
    }, []);
  `,
    [iframeUrl]
  );

  return (
    <>
      <Typography fontSize={14} marginBottom={1}>
        Copy and paste the code below into your website to embed the video
        player.
      </Typography>

      {/* code sample blocks — deliberately dark in both themes, no token role fits */}
      <Box
        padding={2}
        borderRadius={2.25}
        sx={{
          backgroundColor: "#333",
          color: "#ffffff",
          fontWeight: 300,
          lineHeight: "14px",
          fontSize: "12px",
          marginBottom: "20px",
        }}
      >
        <code>{formatEmbedCode}</code>
      </Box>
      <CopyButton text="Website Code" value={formatEmbedCode} />

      <Typography gutterBottom component="div">
        <strong>React Hook</strong>
      </Typography>
      <Typography fontSize={14} marginBottom={1}>
        If you are using react. Add the hook below to your component in addition
        to placing the code from above in the html portion of your component.
      </Typography>
      <Box
        className="rounded-lg "
        padding={0}
        borderRadius={2.25}
        sx={{
          backgroundColor: "#333",
          color: "#ffffff",
          fontWeight: 300,
          lineHeight: "14px",
          fontSize: "12px",
          marginBottom: "20px",
          overflow: "auto",
        }}
      >
        <pre>{formatEmbedReactHookCode}</pre>
      </Box>
      <CopyButton text="React Hook" value={formatEmbedReactHookCode} />
    </>
  );
};
